import React from "react";
import "./Second.css";
import { Container } from "react-bootstrap";
import enterprice from "../../../../Asset/enterprise.svg";
import smes from "../../../../Asset/smes.svg";
import startup from "../../../../Asset/startups.svg";

const Second = () => {
  const cardData = [
    {
      id: 1,
      img: enterprice,
      title: "Enterprise",
      description:
        "For enterprises, we optimize mobile development for maximum efficiency and scalability. With robust frameworks and business intelligence, we build feature-rich apps that align with your organization's processes and objectives.",
    },
    {
      id: 2,
      img: smes,
      title: "SMEs",
      description:
        "SMEs can tap into our technical expertise to implement cutting-edge capabilities on a budget. We fuse innovation with pragmatic solutions to help SMBs punch above their weight with modern mobile apps.",
    },
    {
      id: 3,
      img: startup,
      title: "Startups",
      description:
        "For startups, we balance bold vision with disciplined execution. Our agile approach supports bringing innovative ideas to market quickly. We help startups lay the digital foundation for rapid growth and success.",
    },
  ];
  return (
    <>
      <section className="second-services-sec">
        <Container>
          <div className="top-text-after-second-services">
            <h2>
              BULID APPS THAT <span>DRIVES GROWTH</span>
            </h2>
          </div>
          <p>
            We provide custom mobile app development across industries to help
            companies achieve their unique business goals. Our strategic
            solutions are tailored for:{" "}
          </p>
          <div className="row drive-business">
            {cardData?.map(({ id, img, title, description }) => (
              <div key={id} className="col-xl-4 col-lg-4 col-md-12 col-sm-12">
                <div className="mob-dev-card-wrapper">
                  <div className="icons-sticky">
                    <img alt={title} src={img} />
                  </div>
                  <h5>{title}</h5>
                  <p>{description}</p>
                </div>
              </div>
            ))}
          </div>
        </Container>
      </section>
    </>
  );
};

export default Second;
